import { Box, Progress } from "@chakra-ui/react";

export default function PatientIntakeFlowProgress(props: { isFetching: boolean }) {
  if (props.isFetching) {
    return <Progress isIndeterminate bg="gray.200" h="1px" size="xs" />;
  }

  return <Box bg="gray.200" h="1px" />;
}
